import { render, staticRenderFns } from "./LASAQuestionnairePanels.vue?vue&type=template&id=d324b884&"
import script from "./LASAQuestionnairePanels.vue?vue&type=script&lang=js&"
export * from "./LASAQuestionnairePanels.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/components/views/dashboard/members/id/partial/questionnaires/components/lasa-questionnaire-panels.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports